import type { Incident } from '@/types/Incident'

export interface SortOptionType {
  label: string
  name: string
  sortfn: (a: Incident, b: Incident) => number
}

export default [
  {
    label: 'views.sort.nameAZ',
    name: 'name|',
    sortfn: (a: Incident, b: Incident) => {
      return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
    }
  },
  {
    label: 'views.sort.nameZA',
    name: 'name|desc',
    sortfn: (a: Incident, b: Incident) => {
      return b.name.toLowerCase().localeCompare(a.name.toLowerCase())
    }
  },
  {
    label: 'views.sort.reportedNew',
    name: 'declared_timestamp|desc',
    sortfn: (a: Incident, b: Incident) => {
      const dateA = new Date(a.declared_timestamp ?? 0)
      const dateB = new Date(b.declared_timestamp ?? 0)
      return dateB.getTime() - dateA.getTime()
    }
  },
  {
    label: 'views.sort.reportedOld',
    name: 'declared_timestamp|',
    sortfn: (a: Incident, b: Incident) => {
      const dateA = new Date(a.declared_timestamp ?? 0)
      const dateB = new Date(b.declared_timestamp ?? 0)
      return dateA.getTime() - dateB.getTime()
    }
  },
  {
    label: 'views.sort.editedNew',
    name: 'updated_timestamp|desc',

    sortfn: (a: Incident, b: Incident) => {
      const dateA = new Date(a.updated_at ?? a.declared_timestamp)
      const dateB = new Date(b.updated_at ?? b.declared_timestamp)
      return dateB.getTime() - dateA.getTime()
    }
  },
  {
    label: 'views.sort.editedOld',
    name: 'updated_timestamp|',
    sortfn: (a: Incident, b: Incident) => {
      const dateA = new Date(a.updated_at ?? a.declared_timestamp)
      const dateB = new Date(b.updated_at ?? b.declared_timestamp)
      return dateB.getTime() - dateA.getTime()
    }
  }
] as SortOptionType[]
